import React, { Component } from "react";
import { shuffle, isEqual, filter, sum, orderBy } from "lodash";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import okButtonIcon from "../../../../assets/images/okbutton_icon.png";
import FlipMove from "react-flip-move";

//-----------------------------------------------------------------------------
// Put-In-Order Question Type - PIO
//-----------------------------------------------------------------------------
class PIOTypeQuestion extends Component {
  constructor() {
    super();
    this.state = {
      generatedAnswers: [],
      disableFlipMove: false,
      currentQuestionDeductionScore: 0,
    };
  }

  componentDidMount() {
    const { currentQuestion } = this.props;
    this.generateAnswersSet(
      currentQuestion.AData,
      currentQuestion.IsRandomAnswers,
      currentQuestion.QTypeShort,
      currentQuestion.ADataRandomLines
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentQuestion !== nextProps.currentQuestion) {
      this.generateAnswersSet(
        nextProps.currentQuestion.AData,
        nextProps.currentQuestion.IsRandomAnswers,
        nextProps.currentQuestion.QTypeShort,
        nextProps.currentQuestion.ADataRandomLines
      );
    }
  }

  generateAnswersSet = (
    answerData,
    isRandomAnswers,
    questionType,
    randomLinesCount
  ) => {
    let generatedAnswersArray = [];

    generatedAnswersArray = filter(answerData.split("\n")).map(
      (item, index) => {
        let splittedArray = item.split("|");
        return splittedArray[0] !== ""
          ? {
              id: index + 1,
              answerValue: splittedArray[0],
              optionActualOrder: index + 1,
              optionExpectedOrder: index + 1,
            }
          : null;
      }
    );

    generatedAnswersArray = this.props.getRandomAnswers(
      filter(generatedAnswersArray),
      randomLinesCount
    );

    generatedAnswersArray = orderBy(generatedAnswersArray, "id", "ASC").map(
      (item, index) => {
        return {
          id: index + 1,
          answerValue: item.answerValue,
          optionActualOrder: index + 1,
          optionExpectedOrder: index + 1,
        };
      }
    );
    if (isRandomAnswers === "1") {
      generatedAnswersArray = shuffle(generatedAnswersArray);
    }
    generatedAnswersArray.forEach((listItem, index) => {
      listItem.optionActualOrder = index + 1;
    });

    this.setState({
      generatedAnswers: generatedAnswersArray,
    });
  };

  onClickVerifyPIOAnswer = () => {
    let { generatedAnswers } = this.state;
    let { currentQuestion, currentQuestionId } = this.props;
    let generatedAnswersValues = generatedAnswers.map((item, index) =>
      item.optionActualOrder === item.optionExpectedOrder ? 1 : 0
    );
    let correctCount = sum(generatedAnswersValues);
    let totalCount = generatedAnswersValues.length;
    if (this.props.isTest) {
      //It is test: count points and move to next question

      let questionDetails = {
        number: currentQuestionId,
        questionText: currentQuestion.QLong,
        QTypeShort: currentQuestion.QTypeShort,
        questionGraphicUrl: currentQuestion.QGraphicURL,
        correctAnswersCount: correctCount,
        expectedAnswersCount: totalCount,
        answers: generatedAnswers,
        deductionPercentage: isEqual(totalCount, correctCount) ? 0 : 100,
        isCorrect: isEqual(totalCount, correctCount) ? 1 : 0,
      };
      this.props.addAttendedQuestion(questionDetails);
      this.setState({
        currentQuestionDeductionScore: 0,
      });
    } else {
      // It is quiz: deduct 50% for wrong questions and allow to try again.
      let { currentQuestionDeductionScore } = this.state;

      if (correctCount === totalCount) {
        //All answers are true, give point and move to next question

        let questionDetails = {
          number: currentQuestionId,
          questionText: currentQuestion.QLong,
          QTypeShort: currentQuestion.QTypeShort,
          questionGraphicUrl: currentQuestion.QGraphicURL,
          correctAnswersCount: correctCount,
          expectedAnswersCount: totalCount,
          answers: generatedAnswers,
          deductionPercentage: currentQuestionDeductionScore,
        };
        questionDetails.isCorrect = isEqual(totalCount, correctCount) ? 1 : 0;

        this.props.addAttendedQuestion(questionDetails);
        this.setState({
          currentQuestionDeductionScore: 0,
        });
      } else {
        if (currentQuestionDeductionScore < 100) {
          //deduct 50% from total points and allow to try again -  total 3 tries

          this.setState({
            currentQuestionDeductionScore: currentQuestionDeductionScore + 50,
          });
        } else {
          // all tries completed, give scores for this question and move to next question

          let questionDetails = {
            number: currentQuestionId,
            questionText: currentQuestion.QLong,
            QTypeShort: currentQuestion.QTypeShort,
            questionGraphicUrl: currentQuestion.QGraphicURL,

            correctAnswersCount: correctCount,
            expectedAnswersCount: totalCount,
            answers: generatedAnswers,
            deductionPercentage: currentQuestionDeductionScore,
          };
          questionDetails.isCorrect = isEqual(totalCount, correctCount) ? 1 : 0;
          this.props.addAttendedQuestion(questionDetails);
          this.setState({
            currentQuestionDeductionScore: 0,
          });
        }
      }
    }
  };

  reorderList = (list, startIndex, endIndex) => {
    const [removed] = list.splice(startIndex, 1);
    list.splice(endIndex, 0, removed);
    list.forEach((listItem, index) => {
      listItem.optionActualOrder = index + 1;
    });
    return list;
  };

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const generatedAnswers = this.reorderList(
      this.state.generatedAnswers,
      result.source.index,
      result.destination.index
    );

    this.setState({
      generatedAnswers,
      disableFlipMove: true,
    });
  };

  componentDidUpdate() {
    if (this.state.disableFlipMove) {
      this.setState(() => ({ disableFlipMove: false }));
    }
  }

  getRemainingTriesText = () => {
    switch (this.state.currentQuestionDeductionScore) {
      case 0:
        return "";
      case 50:
        return "2 Attempts Remaining";
      /*
      case 20:
        return "5 Attempts Remaining";
      case 40:
        return "4 Attempts Remaining";
      case 60:
        return "3 Attempts Remaining";
      case 80:
        return "2 Attempt Remaining";
      */
      case 100:
        return "1 Attempt Remaining";
      default:
        return "";
    }
  };

  render() {
    const { generatedAnswers } = this.state;
    const remainingTriesText = this.getRemainingTriesText();
    return (
      <div className="answer-options-container">
        {!this.props.isTest && remainingTriesText && (
          <div className="remaining-attempts-text remaining-attempt-pio">
            {remainingTriesText}
          </div>
        )}
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div ref={provided.innerRef}>
                <FlipMove disableAllAnimations={this.state.disableFlipMove}>
                  <div>
                    {generatedAnswers.map((item, itemIndex) => (
                      <Draggable
                        key={item.id}
                        draggableId={"drag_item_" + item.id}
                        index={itemIndex}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={
                              "single-answer-block is-mch-option flex-content is-pio-option"
                            }
                            // style={this.getItemStyle(
                            //   snapshot.isDragging,
                            //   provided.draggableProps.style
                            // )}
                          >
                            <div className="option-handle-container">
                              <div className="single-icon">
                                <i
                                  className="fa fa-caret-up top-bottom-icon"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <div className="single-icon">
                                <i
                                  className="fa fa-circle middle-icon"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <div className="single-icon">
                                <i
                                  className="fa fa-caret-down top-bottom-icon"
                                  aria-hidden="true"
                                ></i>
                              </div>
                            </div>
                            {item.answerValue}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                </FlipMove>
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <div className="submit-btn-container">
          <div className="submit-btn" onClick={this.onClickVerifyPIOAnswer}>
            <div className="submit-btn-icon">
              <img src={okButtonIcon} alt="ok-icon" />
            </div>
            <div className="submit-btn-text">Submit</div>
          </div>
        </div>
      </div>
    );
  }
}

export default PIOTypeQuestion;
